// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cbc4c081","583":"63d784a2","983":"e99879db"}[chunkId] + ".chunk.js";
};